// Bedrock wants a `network_connectivity` field sent with events.
// for most update list of fields, find `network_connectivity` in
// https://github.com/NerdWallet/app-schemata/blob/master/analytic_pipeline/base_class.yaml#L276
//
// currently: `enum: [WIFI, MOBILE_2G, MOBILE_3G, MOBILE_4G, MOBILE_5G, MOBILE_GSM, IWLAN]`
var NETWORK_CONNECTION_TYPE = {
  WIFI: 'WIFI',
  MOBILE_GSM: 'MOBILE_GSM',
  MOBILE_2G: 'MOBILE_2G',
  MOBILE_3G: 'MOBILE_3G',
  MOBILE_4G: 'MOBILE_4G',
  MOBILE_5G: 'MOBILE_5G',
  IWLAN: 'IWLAN',
  UNKNOWN: 'UNKNOWN'
}; // https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation/effectiveType
// A String containing one of 'slow-2g', '2g', '3g', or '4g'.

var NAVIGATOR_CONNECTION_TYPES_TO_NETWORK_CONNECTION_TYPE = {
  // best guess map to
  'slow-2g': NETWORK_CONNECTION_TYPE.MOBILE_GSM,
  // easily mappable
  '2g': NETWORK_CONNECTION_TYPE.MOBILE_2G,
  '3g': NETWORK_CONNECTION_TYPE.MOBILE_3G,
  '4g': NETWORK_CONNECTION_TYPE.MOBILE_4G,
  // this doesn't exist in spec yet
  '5g': NETWORK_CONNECTION_TYPE.MOBILE_5G
};
export default function getNetworkConnectionTypeWeb() {
  // const { navigator = {} } = window || global;
  var _ref = typeof window === 'undefined' ? global : window,
      _ref$navigator = _ref.navigator,
      navigator = _ref$navigator === void 0 ? {} : _ref$navigator; // use the network api if possible and map it back to the mobile fields


  var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection || {};
  var effectiveType = connection.effectiveType;
  return NAVIGATOR_CONNECTION_TYPES_TO_NETWORK_CONNECTION_TYPE[effectiveType] || NETWORK_CONNECTION_TYPE.UNKNOWN;
}